module.exports = __webpack_public_path__ + "img/techalliance-newsletter.f222fb2b.jpg";